import React, {FunctionComponent} from "react";

const ShutdownBanner: FunctionComponent = () => (
  <div className="shutdown-banner" role="alert">
    <span>
      trainerdx.com is being retired on November 30, 2026. All user data will be permanently deleted.{" "}
      <a href="/shutdown">Details</a>
    </span>
  </div>
);

export default ShutdownBanner;
